<template>
    <div class="modal modal-attach fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-inner">
                        <div class="mb-4">
                            <h4>
                                Upload Files
                            </h4>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-sm-6">
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">File Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="fileInfo.original_filename"
                                    >
                                </div>
                            </div>
                            <div class="col-11 col-sm-5">
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Expiration Date (Optional)</label>
                                    <input
                                        type="date"
                                        class="form-control"
                                        v-model="fileDate"
                                    >
                                </div>
                            </div>
                            <div class="col-lg-12 d-flex mb-4" v-if="fileInfo.file_path">
                                <img src="/img/svg/icons-download.svg" alt="download">
                                <p style="margin: 0; padding-left: 10px;">{{fileInfo.original_filename}}</p>
                            </div>
                            <div class="col-lg-12" v-else>
                                <a href="javascript:void(0)"
                                   class="btn btn--middle w-100 mb-4"
                                   @click="$refs.fileInput.click()"
                                >+Add File</a>
                                <input
                                    type="file"
                                    style="display: none"
                                    @change="selectFile"
                                    ref="fileInput"
                                    accept="application/pdf"
                                >
                            </div>
                        </div>
                        <div class="btns-wrap">
                            <button
                                data-dismiss="modal"
                                class="btn btn--outline-primary">
                                cancel
                            </button>
                            <button
                                class="btn btn--secondary"
                                @click="addApplicantFile">
                                proceed
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ApplicantsServices from "../../../app/Modules/Applicants/resources/js/services/ApplicantsServices";

export default {
    name:'AddNewFileModal',
    props: {
        id: String ,
        userId: Number
    },
    data() {
        return {
            fileInfo: {},
            fileDate: null,
        }
    },
    emits: ['confirm'],
    methods:{
        async addApplicantFile() {
            if(!this.fileInfo.id) {
                this.$showErrorMessage('Please select file or select valid file')
                return
            } else {
                const payload = {
                    original_filename: this.fileInfo.original_filename ,
                    expiration_date: this.fileDate,
                    id: this.fileInfo.id,
                    file_path: this.fileInfo.file_path
                }
                this.$emit('confirm', payload);
                $(`#${this.id}`).modal('hide');
                this.fileInfo = {}
                this.fileDate = null
            }

        },

        async readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        async selectFile(event) {
            const uploadedFiles = this.$refs.fileInput.files;
            if (!uploadedFiles || uploadedFiles.length === 0) {
                this.$showErrorMessage("No file selected");
                return;
            }

            const uploadedFile = uploadedFiles[0];
            try {
                const content = await this.readFileAsync(uploadedFile);
                const file = {
                   file: uploadedFile,
                   name: uploadedFile.name,
                   content,
               }
               await this.sendFileForGettingInfo(file)
            } catch (error) {
                console.error("Error reading file:", error);
            }
        },
        async sendFileForGettingInfo(file) {
            this.$showLoadingMessage()
            const formData = new FormData();
            formData.append('file', file.file);
            try {
                const { data: response } = await ApplicantsServices.getFileInfo(this.userId, formData);
                this.fileInfo = response
                this.$showSuccessMessage('File was uploaded')
            } catch (error) {;
                this.$showErrorMessage('File was not uploaded');
            }
        }
    }
}

</script>

<style scoped>

</style>
